<a *ngIf="route" [attr.id]="id ? id : null" routerLink="{{route}}" class="{{classes}}" name="{{name}}" [attr.disabled]="(state == 'spinner' || state == 'disabled') ? 'disabled' : null">{{text}}</a>
<a *ngIf="link" [attr.id]="id ? id : null" href="{{link}}" class="{{classes}}" name="{{name}}" [attr.disabled]="(state == 'spinner' || state == 'disabled') ? 'disabled' : null">{{text}}</a>
<button *ngIf="!link && !route" [attr.id]="id ? id : null" class="{{classes}}" [attr.name]="name ? name : null" (click)="clickedEvent($event)" [attr.disabled]="( state == 'spinner' || state == 'disabled') ? 'disabled' : null">
    <div *ngIf="state === 'spinner'" class="spinner-container-btn">
        <img class="spinner-btn" src="/_ng/booking/assets/loading_white.svg" />
    </div>
    {{text}}
</button>

